// CustomerSelectionModal.js
import React, { useState, useEffect, useContext, useRef } from 'react';
import 'datatables.net-bs5';
import $ from 'jquery';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import Draggable from 'react-draggable';
function CustomerSelectionModal({ show, onClose, OpportunityList, onSelectOpportunity }) {
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme == "dark") {
        accordTheme = "accordion-header-dark";
    }
    const tableRef = useRef();
    const initDataTable = () => {
        if ($.fn.DataTable.isDataTable(tableRef.current)) {
            console.log('Destroying existing DataTable instance...');
            $(tableRef.current).DataTable().destroy();
        }
        $(tableRef.current).DataTable({
            dom: '<"row"<"col-sm-6 d-flex align-items-center"Bf><"col-sm-6 d-flex justify-content-end"p>>rt',
            pagingType: 'full_numbers',
            language: {
                search: "_INPUT_",
                searchPlaceholder: "Search..."
            },

            lengthChange: false,
            initComplete: function () {
                console.log('DataTable initialization complete.');
                $('.btn-dataTable').css('background', 'none');
                $('.btn-dataTable').css('border', 'none');
                $('.btn-dataTable').removeClass('btn-secondary');
                $('.btn-dataTable').removeClass('btn');
                $('.btn-dataTable').removeClass('btn-dataTable');
                //  $('.dt-search input[type="search"]').css('margin-left', '10px');
                //  $('.dt-search input[type="search"]').css('height', '25px');
            }
        });

        $('#datatable-search-container').append($('.dataTables_filter').html());
        $('.dataTables_filter').remove();
    };

    useEffect(() => {
        if (OpportunityList && OpportunityList.length > 0) {
            console.log('Company list updated, initializing DataTable with data:', OpportunityList);
            initDataTable();
        }
    }, [OpportunityList]);
    const truncateText = (text, maxLength = 15) => {
        if (!text) return '';
        return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    };
    const handleStart = (e, ui) => {
        e.stopPropagation();
    }
    return (
        <div className={`modal fade ${show ? 'show' : ''}`} style={{ display: show ? 'block' : 'none' }} tabIndex="-1">
            <div className="modal-dialog modal-lg">
                <Draggable handle=".modal-content" onStart={handleStart}
                    cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Select Opportunity</h5>
                            <button type="button" className="btn-close" onClick={onClose}></button>
                        </div>
                        <div className="modal-body">
                            <div style={{ "marginLeft": "10px", "marginRight": "0px", "marginTop": "10px" }}>
                                <table className="table table-striped" ref={tableRef} style={{ "width": "100%" }}>
                                    <thead>
                                        <tr>
                                            <th className="no-wrap">
                                                Customer
                                            </th>

                                            <th className="no-wrap">Town/City</th>
                                            <th className="no-wrap">Post Code</th>
                                            <th className="no-wrap">Telephone</th>
                                            <th className="no-wrap">Type</th>
                                            <th className="no-wrap">Status</th>
                                            <th className="no-wrap">Website</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {OpportunityList.map(customer => (
                                            <tr key={customer.ID} onClick={() => onSelectOpportunity(customer)} style={{ cursor: 'pointer' }}>
                                                <td className="no-wrap">{truncateText(customer.CompanyName)}</td>

                                                <td className="no-wrap">{truncateText(customer.City)}</td>
                                                <td className="no-wrap">{truncateText(customer.Postcode)}</td>
                                                <td className="no-wrap">{truncateText(customer.Phone1)}</td>
                                                <td className="no-wrap">{truncateText(customer.CType)}</td>
                                                <td className="no-wrap">{truncateText(customer.vc_AccountStatus)}</td>
                                                <td className="no-wrap">{truncateText(customer.Website)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>
                </Draggable>
            </div>
        </div>
    );
}

export default CustomerSelectionModal;
